module.exports = "dist/46e48ce0628835f68a7369d0254e4283.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Light.ttf
// module id = 210
// module chunks = 0